import React from 'react'
import AnchorLink from '../AnchorLink'

const Standings = ({
  title = 'Table',
  teams = [],
  link = {
    title : '',
    href : '#',
    external: false
  },
  displayKey = 'abbrev',
  params = {},
  isTeamLinkActive = true
}) => {
  const aGroups   = teams || [] /* these are groups not teams passed */
  const target    = link.external ? { target: '_blank' } : {}
  const iGroupLen = aGroups.length || 0
  let aTables     = []

  if ( !iGroupLen ) { /* check here to save work */
    return <article className="sub-module" />
  }

  for ( let i = 0; i < iGroupLen; i++ ) {
    const groupTeams  = aGroups[i].teams || []
    const groupKeys   = aGroups[i].keys || []
    const iTeamLen    = groupTeams.length || 0
    const iKeyLen     = groupKeys.length || 0
    let aRows         = []

    for ( let a = 0; a < iTeamLen; a++ ) {
      const team  = groupTeams[a]
      const stats = groupTeams[a].stats || []
      let highlightCell = false
      if(params.pageType == 'team' && params.team == team.id) {
        highlightCell = true
      }
      let aCells  = []

      for ( let b = 0; b < iKeyLen; b++ ) {
        if ( groupKeys[b].type === 'team' ) {
          if (isTeamLinkActive) {
            aCells.push(<td key={b}><a title={team.displayName} name={team.trackingName} href={team.href}>{team[displayKey]}</a></td>)
          }
          else {
            aCells.push(<td key={b}>{team[displayKey]}</td>)
          }

        } else if ( b === 0 ) {
          aCells.push(<td key={b}>{ stats[b] || '-' }</td>)
        } else {
          aCells.push(<td key={b} className="right">{ stats[b] || '-' }</td>)
        }
      }
      aRows.push(<tr key={a} className={ highlightCell ? 'highlight' : '' }>{ aCells }</tr>)
    }

    aRows.length > 0 ? aTables.push(<TableHead key={'th.' + i} keys={aGroups[i].keys} className={i > 0 ? 'bordered' : ''} abbreviation={aGroups[i].abbreviation}/>,
      <tbody key={'tb.' + i}>
        {aRows}
      </tbody>
    ) : aTables.push(<tbody key={'empty-tbody' + i}></tbody>)

  }

  return (
    <article className="sub-module">
      <header>
        <h1>{title}</h1>
      </header>
      <div className="content">
        <table className="mod-data">
          {aTables}
        </table>
      </div>
      {
        link.href && link.title &&
        <footer>
          <AnchorLink trackingName={link.trackingName} to={link.href} text={link.title} {...target} />
        </footer>
      }
    </article>
  )

}

const TableHead = ({
  keys          = [],
  className     = '',
  abbreviation  = ''
}) => {
  const iLen  = keys.length || 0
  let aCols   = []

  for ( let i = 0; i < iLen; i++ ) {
    aCols.push(<th key={i} className={ (i === 0 || keys[i].type === 'team') ? 'left' : 'right' } title={keys[i].tooltip}>{keys[i].text}</th>)
  }

  return (
    <thead className={className}>
      {
        abbreviation &&
        <tr className="column-group" >
          <th colSpan={iLen}>{abbreviation}</th>
        </tr> || null
      }
      <tr>
        {aCols}
      </tr>
    </thead>
  )
}

export default Standings



/** WEBPACK FOOTER **
 ** ../app/components/common/col-c/Standings.jsx
 **/